import { calculationTypesSlice } from "./calculationTypesSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = calculationTypesSlice;
const moduleUrl = '/api/pricing/pricingConditions/calculationType'

export const setValidationErrors = actions.setValidationErrors;

export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
